<template>
	<v-card>
		<v-card-title
			class="d-flex align-center"
		>
			<v-icon
				icon="$basket"
				start
			/>
			<translate>Orders</translate>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col>
					<model-backend-table
						v-model="items"
						v-model:options="options"
						:sort-by="[{key: sortBy, order: sortDesc}]"
						endpoint="/bo/orders/table"
						:headers="tableHeaders"
						:items-per-page="25"
						:items-per-page-options="[25, 50, 100]"
					>
						<template #item.orderkey="{ item }">
							<a :href="`/bo/orders/view?id=${item.id}`">
								{{ item.orderkey }}
							</a>
						</template>
						<template #item.created_at="{ item }">
							<a :href="`/bo/orders/view?id=${item.id}`">
								{{ item.createdAt }}
							</a>
						</template>
					</model-backend-table>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>

export default {
	name: 'OrdersOverview',

	data () {
		return {
			loading: true,
			items: [],
			options: {
			},
			totalItems: 0,
			sortBy: 'created_at',
			sortDesc: true,
		};
	},

	computed: {
		tableHeaders () {
			return[
				{
					title: this.$gettext('Orderkey'), value: 'orderkey', sortable: false,
				},
				{
					title: this.$gettext('Date'), value: 'created_at', sortable: true,
				},
				{
					title: this.$gettext('Name'), value: 'name', sortable: false,
				},
				{
					title: this.$gettext('Domain'), value: 'domain', sortable: false,
				},
				{
					title: this.$gettext('Reference'), value: 'reference', sortable: false,
				},
			];
		}
	}
};
</script>
